import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-score-faq-modal-v2',
  templateUrl: './score-faq-modal-v2.component.html',
  styleUrls: ['./score-faq-modal-v2.component.css']
})
export class ScoreFaqModalV2Component implements OnInit {

  faqData=[];
  faqDataV1 = [
    {
      title: '',
      description: 'Wondering what assessments are all about? We have got it covered. Here is a quick guide for all the assessment-related queries. Keep scrolling, the answers are right here!',
    },
    {
      title: 'What are Practice Exercises and Touchstones?',
      description: 'Practice Exercises and Touchstones are assessments that help you build your Course Score. You might want to spend some extra minutes reflecting on your responses while you are at it. ',
    },
    {
      title: 'What is Course Score?',
      description: 'Course Score refers to the overall score you get in the course. The maximum score is 100.',
    },
    {
      title: 'How does my score for each exercise contribute to my Course Score?',
      description: 'You will find the score contribution of each exercise mentioned on the screen before you start it. Once you finish the exercise and submit your responses, your  score will appear on the screen.',
    },
    {
      title: 'What metric is the Course Score based on?',
      description: 'Through the assessments, we are trying to get to know you better so we can give you constructive feedback to inculcate these behaviors. At Harappa, behaviors are a function of improving skills, making an effort and building confidence. These are the three measures we use for grading.',
    },
    {
      title: 'How is the scoring done?',
      description: 'We check for how well you have understood the course concepts and your ability to apply them. Your responses to the assessments are graded on a predefined scale, which is based on the type and difficulty of the question.',
    },
    {
      title: 'What if I answer a question partially correct?',
      description: 'In a question, we award partial scores for the options that are attempted correctly.',
    },
    {
      title: 'Who scores my open-ended responses?',
      description: 'Harappa Learning Specialists read your responses to open-ended questions and grade them based on a predefined rubric.',
    },
    {
      title: 'Can I take a second attempt at an exercise?',
      description: 'There is no provision for a second chance once you have attempted an exercise. So spend an extra minute on each question when you are submitting your response. Thinking twice before you submit your responses will also help you internalize the concepts better.',
    },
    {
      title: 'When can I see my Practice Exercise and Touchstone scores?',
      description: 'You can see your scores and feedback for a particular exercise as soon as you submit it. If the Touchstone exercise has an open-ended question that requires feedback from Harappa Learning Specialists, you will be notified accordingly.',
    },
    {
      title: 'When can I see my overall Course Score?',
      description: 'You will be able to see your Course Score and your breakup on Skill, Effort and Confidence after you finish all assessments. The scores for individual exercises can be seen on the dashboard after successfully submitting the exercises. ',
    },
    {
      title: 'When can I download my Harappa Certificate?',
      description: 'You get your certificate at the end of a course after successfully completing all the modules and assessments. You will be able to see your certificate once you have completed the course.',
    },
    {
      title: 'What should I do in case I have any other questions?',
      description: 'Don’t worry! We are just around the corner. Write your query on the Harappa Support Chat on the learning platform or you can email us at support@harappa.education. We are here to answer them.',
    }
  ];
  faqDataV2 = [
    {
      title: '',
      description: 'Here is a quick guide to understand our assessment methodology.',
    },
    {
      title: 'What is an H_Score?',
      description: 'The H_Score is the measure of your performance in a course. It is calculated as a percentage. The maximum H_Score you can get in a course is 100%.',
    },
    {
      title: 'What are Basecamp and Summit?',
      description: 'A Basecamp is a mandatory exercise at the start of the course. A Summit is a mandatory exercise just before the completion of the entire course, including all modules and assessments. Basecamp and Summit enable you to plot the change in your responses to situations, before and after the course journey. Although immensely valuable to your learning journey, these don’t contribute to your course score, or H_Score.',
    },
    {
      title: 'What are the in-video questions?',
      description: 'Questions that appear at various points in the middle of course videos are aimed to help you recall and comprehend concepts and ideas better. Think of them as practice sessions. Your responses to these questions are not scored.',
    },
    {
      title: 'What are Checkpoints and Milestones?',
      description: 'A Checkpoint is an exercise that appears at the end of each module of the course. A Milestone is a rigorous course-end exercise that tests you on all the concepts and frameworks taught across modules. These exercises help assess and evaluate your proficiency to apply the concepts learned. Scores from Checkpoints and Milestones contribute to your H_Score. As soon as you attempt an exercise (a Checkpoint or Milestone), you will be able to see the points that you scored on the exercise.',
    },
    {
      title: 'What metric is the H_Score based on?',
      description: 'The H_Score is a cumulative score based on four parameters—<strong>Skill,</strong> <strong>Effort,</strong> <strong>Confidence,</strong> and <strong>Engagement.</strong> At Harappa, we believe learning good behaviors goes beyond learning new Skills. Learning is also about the Effort you put into imbibing the behaviors and your Confidence in applying them in your everyday life. And, then there is Engagement. The more engaged you are while learning, the higher the chances that you will grasp the concepts better.',
    },
    {
      title: 'How is the H_Score generated?',
      description: 'The H_Score is the sum of points on Skill, Effort, and Confidence that we generate from your responses in the course assessments. Learning patterns on the Harappa platform contribute to the score for Engagement. Your Skills account for 60% of the total H_Score and the rest is derived from your Effort, Confidence, and Engagement.',
    },
    {
      title: 'When can I see my overall H_Score?',
      description: 'You will be able to see your H_Score and its breakdown on Skill, Effort, Confidence, and Engagement after you finish all exercises. The scores for individual exercises can be seen on the course insights page after you have successfully completed all the course exercises.',
    },
    {
      title: 'What does High, Medium and Low on Skill, Effort and Confidence mean?',
      description: 'Your performance on each of the Skill, Effort and Confidence metrics on the Dashboard are rated as High, Medium and Low. These indicators help us build personalized course-end insights for you.',
    },
    {
      title: 'What does thumbs-up or thumbs-down on Engagement mean?',
      description: 'Just like an offline classroom instructor may give grades based on interaction and participation, we measure your online course engagement through your activity on the platform. You will come across various features within the learning platform that are designed to boost both interactivity and aid learning. A thumbs-up means you have engaged well during the course, while thumbs-down is a recommendation that you can do better.',
    },
    {
      title: 'What if my answer to a question is partially correct?',
      description: 'In questions with multiple correct answers, we award partial points for the correct options entered, even if other options are incorrect.',
    },
    {
      title: 'Who scores my open-ended responses?',
      description: 'Some courses have open-ended questions. You will not get immediate feedback on these questions. Once you submit your responses to these questions, Harappa Learning Specialists will evaluate your responses and provide personalized feedback based on the scoring rubric within 48 hours.',
    },
    {
      title: 'Can I attempt an exercise twice/again?',
      description: 'You cannot re-attempt an exercise once you have submitted your responses. We strongly recommend that you check your responses thoroughly before submitting them. Take an extra minute if needed - there is no time limit.',
    },
    {
      title: 'When can I download my Harappa Certificate?',
      description: 'The certificate for a course gets activated after you complete all the modules and assessments in the course. ',
    },
    {
      title: 'How does my performance in the course reflect on my Harappa Certificate?',
      description: 'There are two kinds of Harappa Certificates: a Harappa Certificate of Completion and a Harappa Certificate of Proficiency.<br><br>If you score 40% or more, you are awarded a Harappa Certificate of Proficiency with a proficiency level based on your score as shown in the table below.<br><br> <table class="table table-bordered"><thead><tr><th>Score Range</th><th>Proficiency Level</th></tr></thead><tbody><tr><td>40-59%</td><td>Commendable</td></tr><tr><td>60-79%</td><td>Outstanding</td></tr><tr><td>80-100%</td><td>Exemplary</td></tr></tbody></table> <br>If your final course score is 40% or less, then you are awarded a Harappa Certificate of Completion. Don’t get discouraged, it’s a good start!',
    },
    {
      title: 'What should I do if I have other questions?',
      description: 'Don’t worry! We are right here. Email us anytime at support@harappa.education or speak to the Harappa Learning Support, live on our learning player.',
    }
  ];
  isV2Assessment:boolean=false;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
   this.faqData = this.isV2Assessment?this.faqDataV2:this.faqDataV2;
  }

  close() {
    this.activeModal.close();
  }
}
